import { Component, OnInit } from "@angular/core";
import { environment } from "@env/environment";

@Component({
  selector: "app-manual-page",
  templateUrl: "./manual-page.component.html",
  styleUrls: ["./manual-page.component.scss"],
})
export class ManualPageComponent implements OnInit {
  public href: string = `${
    environment.base_href && "/" + environment.base_href
  }/assets/desvendando-a-plataforma-escritha-modulo1-upgrade.pdf`;
  public inviteAuthor: string = `${
    environment.base_href && "/" + environment.base_href
  }/assets/tutorial-convidar-autor-orientador.pdf`;
  public models: any[] = [
    {
      description: "Canvas da Produção Científica",
      href: `${
        environment.base_href && "/" + environment.base_href
      }/assets/canvas-da-producao-cientifica.pdf`,
    },
  ];

  constructor() {}

  ngOnInit() {}
}
